import { IErrorHandling, OnboardingFormFields } from '@Types/index';

export const PhoneErrorMap = {
  INVALID_PHONE_NUMBER: 4010,
  PHONE_NUMBER_VOIP: 4302,
  PHONE_NUMBER_NOT_US: 43021,
  PHONE_NUMBER_LANDLINE: 4304,
  NEW_PHONE_EXISTS: 4350,
  MFA_CODE_IS_INVALID: 40032,
  AUTHORIZED_USER_PHONE_VALIDATION_ERROR: 50721,
};

export const PhoneErrorsObjectMap = new Map<number, IErrorHandling>([
  [
    PhoneErrorMap.NEW_PHONE_EXISTS,
    {
      errorCode: PhoneErrorMap.NEW_PHONE_EXISTS,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.INVALID_PHONE_NUMBER,
    {
      errorCode: PhoneErrorMap.INVALID_PHONE_NUMBER,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.PHONE_NUMBER_VOIP,
    {
      errorCode: PhoneErrorMap.PHONE_NUMBER_VOIP,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.PHONE_NUMBER_NOT_US,
    {
      errorCode: PhoneErrorMap.PHONE_NUMBER_NOT_US,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.PHONE_NUMBER_LANDLINE,
    {
      errorCode: PhoneErrorMap.PHONE_NUMBER_LANDLINE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.MFA_CODE_IS_INVALID,
    {
      errorCode: PhoneErrorMap.MFA_CODE_IS_INVALID,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_OTP,
      callBack: () => {},
    },
  ],
  [
    PhoneErrorMap.AUTHORIZED_USER_PHONE_VALIDATION_ERROR,
    {
      errorCode: PhoneErrorMap.AUTHORIZED_USER_PHONE_VALIDATION_ERROR,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.PHONE_NUMBER,
      callBack: () => {},
    },
  ],
]);
